'use client';

import AdPlaceholder from './AdPlaceholder';

interface InFeedAdProps {
  slot: string;
  className?: string;
}

const InFeedAd: React.FC<InFeedAdProps> = ({ slot, className = '' }) => {
  return (
    <div className={`my-8 ${className}`}>
      <AdPlaceholder
        slot={slot}
        format="auto"
        style={{ minHeight: '200px' }}
      />
    </div>
  );
};

export default InFeedAd;